export const ACTIONS = {
    addAvailability: '@@timesgrid/addAvailability',
    initialize: '@@timesgrid/initialize',
};

export const TIMESGRID_ROOT_KEY = 'timesgrid';
